import { request } from '../../common/request';
import { workfrontConfiguration as workfrontConfigurationUrl } from '../../common/urls';
import { ClientId } from '../../common/keys';
import { relicApiFail, relicApiSuccess } from './relic';

const RELIC_CASE_CREATION_AVAILABILITY_TRACKING = {
  title: 'Case Creation Availability',
  duration: 10,
};

/**
 * get Workfront configuration
 * */
export const getWorkfrontConfiguration = async () => {
  const requestHeaders = {};
  requestHeaders['Content-Type'] = 'application/json';
  requestHeaders['x-api-key'] = ClientId;
  const workfrontConfigurationStart = performance.now();
  const workfrontConfigurationDuration = Number((performance.now() - workfrontConfigurationStart) );
  try {
    const res = await request(workfrontConfigurationUrl, {
      headers: { ...requestHeaders },
      params: {},
      key: 'workfront-configuration',
    });
    const data = await res.json();
    if (res.ok && data) {
      relicApiSuccess({
        endpoint: workfrontConfigurationUrl,
        duration: workfrontConfigurationDuration,
        ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
      });
      return data;
    }
    relicApiFail({
      status:data.status,
      endpoint: workfrontConfigurationUrl,
      duration: workfrontConfigurationDuration,
      ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
    });
    return null;
  } catch (e) {
    relicApiFail({
      status:e.status,
      endpoint: workfrontConfigurationUrl,
      duration: workfrontConfigurationDuration,
      ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
    });
    throw e;
  }
};
